module.exports = __webpack_public_path__ + "assets/img/btn_footer2.c4776669.png";